import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { label: "Home", to: "/" },
  { label: "Calculator", to: "/calculator", cta: true },
  { label: "How it works", to: "/how-it-works" },
  { label: "Formats", to: "/formats" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8);
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <header
        className={`sticky top-0 z-40 transition-colors duration-200 ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-b border-background-200"
            : "bg-background-50/80 backdrop-blur-sm border-b border-transparent"
        }`}
      >
        <div className="mx-auto max-w-content px-4 md:px-6 h-16 md:h-[72px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/ab81c99bf13c746e82ce9665f9429731/820e8067564a5d8f57c6b05c1c531e9b.png"
              alt="HANDICALC®"
              className="w-12 h-12 object-contain rounded-md"
              loading="eager"
            />
            <span className="flex flex-col leading-tight">
              <span className="font-heading font-bold text-foreground-950 text-base md:text-lg tracking-tight">
                HANDICALC<sup className="text-[10px] font-medium">®</sup>
              </span>
              <span className="text-[11px] md:text-xs text-foreground-600">
                Golf Shot Allowance Calculator
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.to;
              if (link.cta) {
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="ml-2 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
                  >
                    <i className="ri-calculator-line"></i>
                    {link.label}
                  </Link>
                );
              }
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 py-2 rounded-md text-sm whitespace-nowrap cursor-pointer transition-colors ${
                    active
                      ? "text-primary-700 font-semibold"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
            aria-label="Toggle navigation"
            onClick={() => setMobileOpen((v) => !v)}
          >
            <i className={`text-xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </header>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 bg-background-50">
          <div className="px-4 h-16 flex items-center justify-between border-b border-background-200">
            <span className="font-heading font-bold text-foreground-950">
              HANDICALC<sup className="text-[10px] font-medium">®</sup>
            </span>
            <button
              type="button"
              className="w-10 h-10 flex items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 cursor-pointer"
              aria-label="Close menu"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-close-line text-xl"></i>
            </button>
          </div>
          <nav className="px-4 py-6 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-3 rounded-md text-base cursor-pointer ${
                  link.cta
                    ? "bg-primary-600 text-background-50 font-medium text-center mt-2"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </>
  );
}